<template>
    <div class="alerter">

        <transition name="pop">
            <div class="alerter__wrap overlay" v-if="isVisible" @click.prevent="getAttention">
                <div class="alerter__dialog" :class="{ attention: needsAttention }">
                    <div class="alerter__content">
                        <slot>
                            <h2 v-if="title" class="alerter__first-child">{{ title }}</h2>
                            <p v-if="message" :class="title ? '' : 'alerter__first-child'">{{ message }}</p>
                        </slot>
                    </div>
                    <div class="alerter__actions">
                        <component :is="action.primary ? 'primary-button' : 'a'"
                            href="#"
                            v-for="action in actions"
                            :key="action.name"
                            @clicked.prevent.stop="fire(action)"
                            @click.prevent.stop="fire(action)"
                            :class="{ 'tag': !action.primary, 'button-timid': !action.primary, 'button-timid--warning': action.danger }"
                            >{{ action.name }}</component>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>


<script>
import PrimaryButton from './PrimaryButton.vue'
export default {
    components: { PrimaryButton },

    data: function() {
        return {
            isVisible: false,
            title: '',
            message: '',
            actions: [],
            needsAttention: false,
        }
    },

    methods: {
        ask: function(title, message, actions) {
            this.reset()
            title && (this.title = title)
            message && (this.message = message)
            actions && (this.actions = actions)
            this.isVisible = true
        },
        fire: function(action) {
            action.action && action.action()
            this.reset()
        },
        reset: function() {
            this.isVisible = false
            this.message = ''
            this.title = ''
            this.actions = [{ name: 'ok' }]
        },

        getAttention: function() {
            this.needsAttention = true
            setTimeout(() => this.needsAttention = false, 500)
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .alerter {
        &__wrap {
            z-index: $z-index-alerter;

            display: flex;
            justify-content: center;
            align-items: center;
            -webkit-tap-highlight-color: rgba(0,0,0,0);

            * {
                -webkit-tap-highlight-color: initial;
            }
        }
        &__dialog {
            width: 440px;
            max-width: 90%;
            margin-top: -10%;

            background-color: $color-yellow;
            border-radius: 4px;
            font-family: $font-body;
            box-shadow: 0 10px 70px rgba(0,0,0,0.3);

            overflow: hidden;

            &.attention {
                animation: pulse2 .3s ease;
            }

        }
        &__content {
            padding: 2em 2em 1em;
        }

        &__first-child {
            margin-top: 0;
        }

        &__actions {
            padding: 0 2em;
            text-align: right;
            background-color: darken($color-yellow, 5%);
            border-top: 1px solid darken($color-yellow, 10%);

            .button-timid {
                padding-left: 10px;
                padding-right: 10px;
                &:hover, &:active {
                    color: saturate(darken($color-primary, 10%), 25%);
                }
                &--warning {
                    &:hover, &:active {
                        color: saturate(darken($color-red, 10%), 10%);
                    }
                }
            }

            .primary-button {
                margin-left: 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Alerter.vue?554df8b0